<div class="menu-host">
  <button type="button" class="btn-icon menu-trigger" [matMenuTriggerFor]="menu">
    <app-svg-icon
      src="../../../../assets/icons/menu-bars-icon.svg"
      width="22px"
      height="22px"
    >
    </app-svg-icon>
  </button>

  <mat-menu #menu="matMenu" class="app-menu-panel" panelClass="app-menu-panel">
    <button
      *ngFor="let route of routes"
      mat-menu-item
      class="menu-btn"
      [class.menu-btn-active]="isRouteActive(route.link)"
      [class.menu-btn-exit]="route.link === '/sair'"
      [routerLink]="route.link"
    >
      {{ route.name }}
    </button>
  </mat-menu>
</div>
